import type { LostDate } from './report-schema.js';

export interface ParsedLostDate {
  value: LostDate | null;
  future: boolean;
}

export function localDay(date: Date): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Warsaw',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}

function shiftDays(date: Date, days: number): Date {
  const shifted = new Date(date);
  shifted.setUTCDate(shifted.getUTCDate() + days);
  return shifted;
}

export function parseLostDate(text: string, now = new Date()): ParsedLostDate {
  const normalized = text.toLocaleLowerCase('en-US');
  if (/don['’]?t know (?:when|the date)/iu.test(normalized)) {
    return { value: { kind: 'UNKNOWN' }, future: false };
  }

  let day: string | null = null;
  if (/\byesterday\b/iu.test(normalized)) day = localDay(shiftDays(now, -1));
  else if (/\btoday\b/iu.test(normalized)) day = localDay(now);
  else {
    const isoMatch = /\b(\d{4})-(\d{2})-(\d{2})\b/u.exec(normalized);
    const localMatch = /\b(\d{1,2})[.\/](\d{1,2})[.\/](\d{4})\b/u.exec(normalized);
    const parts = isoMatch
      ? { year: isoMatch[1], month: isoMatch[2], date: isoMatch[3] }
      : localMatch
        ? { year: localMatch[3], month: localMatch[2], date: localMatch[1] }
        : null;
    if (parts) {
      const date = new Date(
        Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.date), 12),
      );
      if (
        date.getUTCFullYear() === Number(parts.year) &&
        date.getUTCMonth() === Number(parts.month) - 1 &&
        date.getUTCDate() === Number(parts.date)
      ) {
        day = `${parts.year}-${parts.month?.padStart(2, '0')}-${parts.date?.padStart(2, '0')}`;
      }
    }
  }

  if (!day) return { value: null, future: false };
  return {
    value: { kind: 'KNOWN', start: day, end: day },
    future: day > localDay(now),
  };
}
